import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/apps/sb-shell/components/footer/siteFooter/SiteFooterLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/apps/sb-shell/components/visitor-setup/Analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/apps/sb-shell/components/visitor-setup/DatadogInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UtmCookieSetup"] */ "/home/circleci/project/apps/sb-shell/components/visitor-setup/UtmCookieSetup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Provider"] */ "/home/circleci/project/node_modules/@radix-ui/react-tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/packages/builder/clientUtils.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Slider"] */ "/home/circleci/project/packages/design-system/dist/index.es10.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toast","ToastProvider"] */ "/home/circleci/project/packages/design-system/dist/index.es13.js");
;
import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/home/circleci/project/packages/design-system/dist/index.es14.js");
;
import(/* webpackMode: "eager", webpackExports: ["RadioGroup"] */ "/home/circleci/project/packages/design-system/dist/index.es15.js");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogClose","DialogContent","DialogDescription","DialogFooter","DialogHeader","DialogOverlay","DialogPortal","DialogTitle","DialogTrigger"] */ "/home/circleci/project/packages/design-system/dist/index.es16.js");
;
import(/* webpackMode: "eager", webpackExports: ["TabsContent","TabsList","TabsRoot","TabsTrigger"] */ "/home/circleci/project/packages/design-system/dist/index.es18.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/home/circleci/project/packages/design-system/dist/index.es2.js");
;
import(/* webpackMode: "eager", webpackExports: ["RichText"] */ "/home/circleci/project/packages/design-system/dist/index.es5.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/home/circleci/project/packages/design-system/dist/index.es6.js");
;
import(/* webpackMode: "eager", webpackExports: ["CollapsibleContent","CollapsibleRoot","CollapsibleTrigger"] */ "/home/circleci/project/packages/design-system/dist/index.es8.js");
